import { render } from "./PelangganModal.vue?vue&type=template&id=46f44182&scoped=true"
import script from "./PelangganModal.vue?vue&type=script&lang=js"
export * from "./PelangganModal.vue?vue&type=script&lang=js"

import "./PelangganModal.vue?vue&type=style&index=0&id=46f44182&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46f44182"

export default script